import { cloneElement } from 'react'

import { RouterLink } from 'src/routes/components'
import { NAVIGATION_BLANK_PARAMS } from 'src/util/navigation.helpers'

// ----------------------------------------------------------------------

export function createNavItem({
  path,
  icon,
  info,
  depth,
  render,
  hasChild,
  externalLink,
  onClickNav,
  enabledRootRedirect
}) {
  const rootItem = depth === 1
  const subItem = !rootItem
  const subDeepItem = Number(depth) > 2
  const linkProps = onClickNav
    ? {
        onClick: onClickNav
      }
    : externalLink
      ? { href: path, ...NAVIGATION_BLANK_PARAMS }
      : { component: RouterLink, to: path }

  const baseProps =
    hasChild && !enabledRootRedirect ? { component: 'div' } : linkProps

  /**
   * Render @icon
   */
  let renderIcon = null

  if (icon && render?.navIcon && typeof icon === 'string') {
    renderIcon = render?.navIcon[icon]
  } else {
    renderIcon = icon
  }

  /**
   * Render @info
   */
  let renderInfo = null

  if (info && render?.navInfo && Array.isArray(info)) {
    const [key, value] = info
    const element = render.navInfo(value)[key]

    renderInfo = element ? cloneElement(element) : null
  } else {
    renderInfo = info
  }

  return {
    subItem,
    rootItem,
    subDeepItem,
    baseProps,
    renderIcon,
    renderInfo
  }
}
